var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHand(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Hand") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Hand",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(-0.005000, -0.005000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 24.01 0 24.01 24.01 0 24.01"
  }), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(3.005000, 3.005000)",
    id: "Path",
    stroke: "#BABABA",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.876688223,7.82337055 C1.82416266,7.02907695 3.20659866,7.09971911 4.07146412,7.98533063 L5.53482321,9.47915396 L5.53482321,3.45217126 C5.53482321,1.10030408 7.78886826,-0.560648269 9.97210561,0.183678925 L14.6976765,1.79294189 C16.0750548,2.26159234 17.0039844,3.57967175 17.0039844,5.06143422 L17.0039844,12.1222047 C17.0039844,15.4044809 14.3992726,18.0664844 11.1876378,18.0664844 L8.44636831,18.0664844 C6.61379765,18.0664844 4.88912444,17.1843188 3.78991922,15.6853265 L0.478816396,11.165951 C-0.284895203,10.1218254 -0.109561856,8.64867779 0.876688223,7.82337055 L0.876688223,7.82337055 Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHand);
export default __webpack_public_path__ + "static/media/Hand.57521d911b527643018480b27a10f380.svg";
export { ForwardRef as ReactComponent };